import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  // BehaviorSubjects to hold active tab name and dashboard type
  private activeTabSubject = new BehaviorSubject<string>(localStorage.getItem('activeTab') || 'Dashboard');
  private dashboardTypeSubject = new BehaviorSubject<string>(localStorage.getItem('dashboardType') || 'Order'); // Holds the active tab name
//   private dashboardTypeSubject = new BehaviorSubject<string | null>(null); // Holds the dashboard type

  // Observables for components to subscribe to
  activeTab$ = this.activeTabSubject.asObservable(); // Observable for the active tab name
  dashboardType$ = this.dashboardTypeSubject.asObservable(); // Observable for the dashboard type

  /**
   * Sets the active tab name
   * @param tabName The name of the active tab
   */
  setActiveTab(tabName: string): void {
    localStorage.setItem('activeTab', tabName);
    this.activeTabSubject.next(tabName);
  }

  /**
   * Gets the current active tab name
   * @returns Observable of the active tab name
   */
  getActiveTab(): Observable<string> {
    return this.activeTab$;
  }

  /**
   * Sets the current dashboard type
   * @param dashboardType The type of the dashboard
   */
  setDashboardType(dashboardType: string): void {
    localStorage.setItem('dashboardType', dashboardType);
    this.dashboardTypeSubject.next(dashboardType);
  }

  /**
   * Gets the current dashboard type
   * @returns Observable of the dashboard type
   */
  getDashboardType(): Observable<string | null> {
    return this.dashboardType$;
  }
}
